import { Component, Input, OnInit } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SparepartsService } from '../../service/spareparts.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { EntryDetailComponent } from '../entry-detail/entry-detail.component';
import { DatePipe } from '@angular/common';
import endOfMonth from 'date-fns/endOfMonth';
import startOfMonth from 'date-fns/startOfMonth';

@Component({
  selector: 'app-entry-spare',
  templateUrl: './entry-spare.component.html',
  styleUrls: ['./entry-spare.component.less']
})
export class EntrySpareComponent implements OnInit {

  @Input() cno = null;
  validateForm: FormGroup;
  entryTypes = [];
  // selectedValue: number;
  listOfData = [];
  // spareName: string;
  startRow: number;
  // 分页查询条件
  pageIndex: number;
  pageSize: number;
  isShowDown = false;
  isShowLeft = true;
  total = 0;
  loading = true;
  ranges = { 今天: [new Date(), new Date()], 本月: [startOfMonth(new Date()), endOfMonth(new Date())] };
  private datePipe: DatePipe = new DatePipe('zh-cn');
  constructor(
    private fb: FormBuilder,
    private modal: NzModalService,
    public message: NzMessageService,
    private router: Router,
    private dataService: SparepartsService
  ) {
    this.startRow = 1;
    this.pageIndex = 1;
    this.pageSize = 10;
    //  this.selectedValue = 999;
  }


  ngOnInit(): void {
    this.validateForm = this.fb.group({ typeId: null, spareName: null, date: null, cno: this.cno });
    this.initTypeData();
    //  this.spareName = null;
    this.queryStockData(1);
  }

  /**
   * 查询入库单类型信息
   */
  async initTypeData() {
    const result = await this.dataService.queryEntryOutType(0);
    if (result === null) {
      return;
    } else {
      for (const data of result) {
        const node = {
          title: data.dictLabel,
          value: data.dictValue,
          key: data.dictValue
        };
        this.entryTypes.push(node);
      }
    }

  }

  /**
   * 查询入库单记录数据
   * @param flag 1表示点击搜索按钮，2表示翻页
   */
  async queryStockData(flag: number) {
    if (flag === 1) {
      this.pageIndex = 1;
      this.pageSize = 10;
    }
    const result = await this.dataService.queryEnrtryData(this.validateForm.value, this.pageIndex, this.pageSize);
    this.loading = false;
    if (result.code !== 200) {
      this.message.create('error', '入库记录查询失败!');
      return;
    } else {
      this.listOfData = result.data.list;
      this.listOfData.forEach(element => {
        element.createTime = this.formatDate(element.createTime);
      });
      this.total = result.data.total;
      this.startRow = result.data.startRow;
    }
  }
  /**
   * 格式化Date
   * @param date 日期
   */
  public formatDate(date: any): string {
    return this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss');
  }

  openOtherCondition() {
    this.isShowLeft = false;
    this.isShowDown = true;
  }

  closeOtherCondition() {
    this.isShowLeft = true;
    this.isShowDown = false;
  }

  submitForm() {
    this.queryStockData(1);
  }

  resetForm() {
    this.validateForm.setValue({ typeId: null, spareName: null, date: null, cno: null });
    this.queryStockData(1);
  }
  /**
   * 删除入库记录
   */
  async deleteData(stNo: string) {
    this.modal.confirm({
      nzTitle: '<i>确认要删除该入库记录信息?</i>',
      nzOnOk: async () => {
        const result = await this.dataService.deleteEntryData(stNo);
        if (result === 0) {
          this.message.create('error', '入库记录删除失败!');
        } else {
          this.message.create('success', '入库记录删除成功!');
          this.queryStockData(2);
        }
      }
    });
  }
  /**
   * 查询入库单详情
   * @param weNo 入库单编号
   */
  async DetailData(weNo: string, wetNo: number, deliver: string, cid: string) {
    const modals = this.modal.create({
      nzTitle: '入库单[' + weNo + ']详情',
      nzContent: EntryDetailComponent,
      nzStyle: { top: '20px' },
      nzWidth: 1000,
      nzFooter: null,
      nzMaskClosable: false,
      nzComponentParams: {
        entryTypes: this.entryTypes,
        no: weNo,
        typeId: wetNo,
        shr: deliver,
        cid
      }
    });
    modals.afterClose.subscribe(
      {
        next: num => {
          if (num === 'success') {
            this.resetForm();
            this.queryStockData(2);
          }
        }
      }
    );
  }

  onPageIndexChange(pageIndex): void {
    this.pageIndex = pageIndex;
    this.queryStockData(2);
  }


  /**
   * 创建入库单
   */
  createEntry() {
    const modals = this.modal.create({
      nzTitle: '创建-入库单',
      nzContent: EntryDetailComponent,
      nzStyle: { top: '20px' },
      nzWidth: 1000,
      nzFooter: null,
      nzMaskClosable: false,
      nzComponentParams: {
        entryTypes: this.entryTypes,
        no: null,
        typeId: 0,
        shr: null
      }
    });
    modals.afterClose.subscribe(
      {
        next: num => {
          if (num === 'success') {
            this.resetForm();
            this.queryStockData(1);
          }
        }
      }
    );
  }
  /**
   * 库存数据
   */
  stockData() {
    this.router.navigate(['/web/facility/SparePartsManagement']);
  }
  /**
   * 领料单管理
   */
  getSparParts() {
    this.router.navigate(['/web/facility/TakeSpareParts']);
  }
  /**
   * 出库单管理
   */
  outSpareParts() {
    this.router.navigate(['/web/facility/OutSpareParts']);
  }
  onChange(result: Date[]): void {
    // console.log('From: ', result[0], ', to: ', result[1]);
    // console.log('date:' + this.validateForm.value.date[0]);
  }
}
